const url =
  window &&
  window.location &&
  `${window.location.protocol}//${window.location.hostname}`;

export const configMap = {
  // LOCAL
  "https://local-apps.axahealth.intraxa":"DevEP",
  "https://dev-apps.health-on-line.intraxa":"DevEP",
  "http://localhost": "QAEP",
  "https://localhost": "QAEP",

  // DV
  "https://osspa-web-dv.z-ppp-dv-ase01.xpzcloud.com":"DevEP",
  "https://osspa-web-dv-axa.z-ppp-dv-apps.xpzcloud.com":"DevEP",
  "https://osspa-web-dv-hol.z-ppp-dv-apps.xpzcloud.com":"DevEP",

  // QA
  "https://osspa-web-qa.z-ppp-dv-ase01.xpzcloud.com":"QAEP",
  "https://osspa-web-qa-axa.z-ppp-dv-apps.xpzcloud.com":"QAEP",
  "https://osspa-web-qa-hol.z-ppp-dv-apps.xpzcloud.com":"QAEP",

  // PP
  "https://osspa-web-pp.z-ppp-pp-ase01.xpzcloud.com": "PPEP",
  "https://apps.onlineapps.pp.axahealth.co.uk": "PPEP",
  "https://pp-app.health-on-line.co.uk": "PPEP",

  // PR
  "https://osspa-web-pr.z-ppp-pr-ase01.xpzcloud.com": "ProdEP",
  "https://apps.axahealth.co.uk": "ProdEP",
  "https://apps.health-on-line.co.uk": "ProdEP",

  // DR
  "https://osspa-web-dr.z-ppp-pp-ase01.xpzcloud.com": "DREP",
  "https://apps.onlineapps.dr.axahealth.co.uk": "DREP",
  "https://dr-app.health-on-line.co.uk": "DREP"
};

let domainEP = configMap[url];
export const EPDomain_ROOT = `${domainEP}`;